module.exports = __webpack_public_path__ + "static/media/product-summary-4.98d70f63.jpg";